import { IMessage } from '@base/features/message/message';
import { getRequiredEnv } from '@base/utils/helpers';
import { useScript } from '@utils/hooks';
import React, { useEffect } from 'react';
import { container } from 'tsyringe';

export default function useAppleLogin() {
  const message: IMessage = container.resolve('message');
  const script = useScript(
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
  );

  useEffect(() => {
    if (script !== 'ready') return;
    (window as any).AppleID.auth.init({
      clientId: getRequiredEnv('NX_APPLE_APP_ID'),
      scope: 'name email',
      nonce: 'nonce',
      redirectURI: window.location.origin,
      usePopup: true,
    });
  }, [script]);

  async function login() {
    try {
      const res = await (window as any).AppleID.auth.signIn();
      const { code, id_token } = res.authorization;
      // Жду что-то от Онохова.
      console.log(code, id_token);
    } catch (e: any) {
      message.error(e.error);
    }
  }

  return { login };
}
